import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators,AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { DataTransferService } from '../../cat-edit/data-transfer.service';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { MessageService } from 'primeng/api';
import { PDFDocument, degrees } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist';
import { inject } from '@angular/core';
import { PdfjsWorkerBootstrapService } from 'src/app/services/pdfjs-worker-bootstrap.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PdfResizeService } from 'src/app/services/pdf-resize.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SafeHtmlService } from 'src/app/services/safe-html.service';
import * as DOMPurify from 'dompurify';
import { PdfSecurityService } from 'src/app/services/pdfsecurity.service';
import { AUTO_SIGNATURE_CONSTANTS } from 'src/app/models/e-sign-details.constants';
import { PdfValidationService } from 'src/app/services/pdf-validation.service';

interface Mime {
  mime: string;
  pattern: (number | undefined)[];
}

const imageMimes: Mime[] = [
  {
    mime: 'application/pdf',
    pattern: [0x25, 0x50, 0x44, 0x46],
  },
];

@Component({
    selector: 'app-e-sign-upload',
    templateUrl: './e-sign-upload.component.html',
    styleUrls: ['./e-sign-upload.component.scss'],
    standalone: false
})
export class ESignUploadComponent implements OnInit {
  @Input() uploadFileData: any = [];
  @Output() uploadFileChange: EventEmitter<any> = new EventEmitter<[]>();
  branches: any;
  fileName: string = 'Selected File';
  selectedBranch: any;
  productDetails: FormGroup;
  selectedDocumentType = '';
  safePreviewContent: string = '';
  uploadFiles: File[] = [];
  showUploadPage: boolean = true;
  selectFile: any;
  isDocUploaded: boolean = false;
  showFileName: boolean = false;
  base64Data: any = '';
  submitted: boolean = false;
  enableRefIdField: boolean;

  isDragOver = false;

  // Cloud import Declarations
  showGoogleDriveModal = false;
  showDropboxModal = false;
  showOneDriveModal = false;
  visible: boolean = false;
  showLinkModal: boolean = false;
  pdfUrl = '';
  downloadingFromUrl = false;
  isEditorVisible: boolean = false;
  currentPdfToEdit: string | Uint8Array | null = null;
  currentFileName: string = '';

  @ViewChild('closeUploadPopupBtn') closeUploadPopupBtn!: ElementRef;
  @ViewChild('uploadSuccessModal') uploadSuccessModal!: ElementRef;
  @ViewChild('uploadDocSuccessModalPopup')
  uploadDocSuccessModalPopup!: ElementRef;
  @Input() uploadDocumentsData: any = [];
  @Output() productDetailsChange: EventEmitter<any> = new EventEmitter<[]>();
  selectedValue: any;
  chooseFile: boolean = false;
  backupUploadFiles: File[] = [];
  previewModalVisible: boolean = false;
  previewFile: File | null = null;
  previewFileName: string = '';
  activePreviewIndex: number = -1;
  previewModalMode: 'upload' | 'preview' = 'preview';
  stagedUploadFiles: File[] = [];
  previewModalFiles: File[] = [];
  popupPreviewPdfSrc: any = null;
  popupPreviewBytes: Uint8Array | null = null;
  popupPreviewPage: number = 1;
  popupPreviewTotalPages: number = 1;
  popupPreviewZoom: number = 1.0;
  hasLandscapePages: boolean = false;
  isRotating: boolean = false;
  totalPages: number = 0;
  mergedPages: number = 0;
  pageHeight: number[];
  pageWidth: number[];
  pageImages: any = [];
  noBranch: boolean = false;
  selectedPageSize = 'A4'; // Default page size
  @ViewChild('fileInput') fileInput: any;
  @ViewChild('pdfCanvas') pdfCanvas?: ElementRef<HTMLCanvasElement>;
  private pdfjsWorkerBootstrap = inject(PdfjsWorkerBootstrapService);
  isRenderingPdf: boolean = false;
  pdfRenderError: boolean = false;
  private loadedPdfDoc: any = null;
  pdfPreviewUrl: SafeResourceUrl | null = null;
  isPreviewModalOpen = false;
  resizePDFData: any;
  fileSizeError: boolean;
  signatureError: boolean = false;
  signatureErrorMessage: string = '';
  securityError: boolean = false;
  
  get dropboxEnabled(): boolean {
    return this.storageService?.getDropBoxEnabled() || false;
  }
 get isEditPdfEnabled(): boolean {
  // Return false if service is missing OR if the stored value is false
    return !!this.storageService?.getEditPdf();
  }
  referenceIdValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      const validPattern = /^[a-zA-Z0-9_-]*$/;
      return validPattern.test(value) ? null : { invalidChars: true };
    };
  }

  constructor(
    private formBuilder: FormBuilder,
    private catUploadService: CatUploadService,
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
    private dataTransferService: DataTransferService,
    private router: Router,
    private storageService: StorageService,
    private pdfResizeService: PdfResizeService,
    private sanitizer: DomSanitizer,
    private safeHtmlService: SafeHtmlService,
    private pdfSecurityService: PdfSecurityService,
    private pdfValidationService: PdfValidationService,
    private cdr: ChangeDetectorRef
  ) {
    this.productDetails = this.formBuilder.group({
      branchName: ['Selected Branch', [Validators.required]],
      referenceNumber: ['',[Validators.maxLength(80),Validators.required, this.referenceIdValidator()]],
      documentType: ['pdf', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.branches = [{ label: 'Indiranagar', value: 'Indiranagar' }];
    this.selectFile = [{ label: 'Select', value: 'Select' }];

    if (this.uploadFileData !== undefined) {
      this.uploadFiles = this.uploadFileData.uploadFiles;
      this.fileName = this.uploadFileData.fileName;
      this.uploadFileData.base64Doc
        ? (this.base64Data = this.uploadFileData.base64Doc)
        : (this.base64Data = this.uploadFileData.file);
      this.showFileName = true;
    } else {
      this.showFileName = false;
    }

    this.getRefIdConsent();
    this.setSelectedBranchValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.uploadFileData.currentValue) {
      const data = changes.uploadFileData.currentValue;
      if (data) {
        this.productDetails.controls['branchName'].setValue(data.name);
        this.noBranch = false;
      }
    }
  }

  onResizeCheckboxChanged(value: boolean) {
    this.resizePDFData = value;
  }

  async onFileChange(event: any) {
    const files: FileList = event.target.files;
    const fileArray: File[] = Array.from(files) as File[];
    const maxFileSize: number = 15 * 1024 * 1024; // 15MB — keeps Base64 output (~1.33x) safely under eMudhra's 25MB payload limit
    this.resetErrors();

    // 1. FILTER: Only PDF files
    const pdfFiles = fileArray.filter((file) => {
      return (
        file.type === 'application/pdf' ||
        file.name.toLowerCase().endsWith('.pdf')
      );
    });

    // Check if any non-PDF files were selected
    const nonPdfFiles = fileArray.filter((file) => {
      return (
        file.type !== 'application/pdf' &&
        !file.name.toLowerCase().endsWith('.pdf')
      );
    });

    if (nonPdfFiles.length > 0) {
      this.showError(
        'Invalid File Type',
        `Only PDF files are allowed. Rejected: ${nonPdfFiles
          .map((f) => f.name)
          .join(', ')}`,
        'warn'
      );
      return;
    }

    // 2. SIZE VALIDATION
    const oversizedFiles = pdfFiles.filter((file) => file.size > maxFileSize);
    if (oversizedFiles.length > 0) {
      this.fileSizeError = true;
      this.showError(
        'File Too Large',
        `Files exceeding 15MB limit: ${oversizedFiles
          .map((f) => f.name)
          .join(', ')}. Please upload a smaller PDF so it can be processed within the e-sign gateway's size limits.`,
        'error'
      );
      return;
    }

    // 3. SECURITY VALIDATION (NEW)
    try {
      const securityResults = await Promise.all(
        pdfFiles.map((file) =>
          this.pdfSecurityService.validateAndSanitizePDF(file)
        )
      );

      // Separate e-signed files from other malicious files
      const eSignedFiles = pdfFiles.filter(
        (_, index) => securityResults[index].isESigned === true
      );

      const maliciousFiles = pdfFiles.filter(
        (_, index) =>
          !securityResults[index].isValid && !securityResults[index].isESigned
      );

      // Handle e-signed PDFs with special message
      if (eSignedFiles.length > 0) {
        this.securityError = true;
        this.showError(
          'Electronic Signature Detected',
          `This file contains electronic signature: ${eSignedFiles
            .map((f) => f.name)
            .join(', ')}`,
          'warn'
        );
        return;
      }

      // Handle other security threats
      if (maliciousFiles.length > 0) {
        this.securityError = true;
        const errorDetails = maliciousFiles
          .map((file, idx) => {
            const fileIndex = pdfFiles.indexOf(file);
            return `• ${file.name}: ${securityResults[fileIndex].reason}`;
          })
          .join('\n');

        this.showError(
          'Security Threat Detected',
          `The following PDF(s) failed security validation:\n${errorDetails}`,
          'error'
        );
        return;
      }
    } catch (error) {
      console.error('Security validation error:', error);
      this.securityError = true;
      this.showError(
        'Validation Failed',
        'Unable to validate PDF security. Please try again or contact support.',
        'error'
      );
      return;
    }

    // 4. SIGNATURE CHECK
    try {
      const signatureCheckResults = await Promise.all(
        pdfFiles.map((file) => this.checkPdfForSignatures(file))
      );

      const filesWithSignatures = pdfFiles.filter(
        (_, index) => signatureCheckResults[index]
      );

      if (filesWithSignatures.length > 0) {
        this.signatureError = true;
        this.showError(
          'Signed PDF Detected',
          `The following PDF(s) contain signatures and cannot be uploaded: ${filesWithSignatures
            .map((f) => f.name)
            .join(', ')}`,
          'warn'
        );
        return;
      }
    } catch (error) {
      console.error('Signature check error:', error);
      this.signatureError = true;
      this.showError(
        'Processing Error',
        'Error checking PDF signatures. Please try again.',
        'error'
      );
      return;
    }

    // 5. ALL VALIDATIONS PASSED - Process files
    await this.processValidFiles(pdfFiles);
  }

  private async processValidFiles(fileArray: File[]) {
    try {
      // Generate secure preview for first file
      if (fileArray.length > 0) {
        await this.generateSecurePreview(fileArray[0]);
      }

      // Close the Upload Document bootstrap modal
      if (this.closeUploadPopupBtn?.nativeElement) {
        this.closeUploadPopupBtn.nativeElement.click();
      }

      // Stage files and immediately display preview modal in upload mode
      this.stagedUploadFiles = [...fileArray];
      this.previewModalMode = 'upload';
      if (fileArray.length > 1) {
        this.activePreviewIndex = -1;
        this.previewFile = null;
        this.previewModalFiles = [...fileArray];
        this.previewFileName = fileArray.map(f => f.name).join(', ');
      } else {
        this.activePreviewIndex = 0;
        this.previewFile = fileArray[0];
        this.previewModalFiles = [fileArray[0]];
        this.previewFileName = fileArray[0].name;
      }
      this.previewModalVisible = true;
      this.cdr.detectChanges();
    } catch (error) {
      console.error('File processing error:', error);
      this.showError(
        'Processing Failed',
        'Error processing files. Please try again.',
        'error'
      );
    }
  }

  private resetErrors() {
    this.fileSizeError = false;
    this.signatureError = false;
    this.securityError = false;
  }

  private showError(
    summary: string,
    detail: string,
    severity: 'error' | 'warn' | 'info'
  ) {
    this.messageService.add({
      severity: severity,
      summary: summary,
      detail: detail,
      life: 5000,
    });
  }

 private async checkPdfForSignatures(file: File): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async (e) => {
        try {
          const arrayBuffer = e.target?.result as ArrayBuffer;
          const uint8Array = new Uint8Array(arrayBuffer);

          // Method 1: Check for digital signature dictionaries
          const pdfText = new TextDecoder('latin1').decode(uint8Array);

        // Block only user-applied signatures
        // adbe.pkcs7.sha1 intentionally excluded — auto-applied by PDF generation tools
        const blockedSubFilters = [
          'adbe\\.pkcs7\\.detached',
          'adbe\\.x509\\.rsa_sha1',
          'ETSI\\.CAdES\\.detached',
          'ETSI\\.RFC3161',
        ];

        const subFilterPattern = new RegExp(
          `\\/SubFilter\\s*\\/(${blockedSubFilters.join('|')})`,
          'i'
        );

        const hasBlockedSubFilter = subFilterPattern.test(pdfText);

        // Must also have ByteRange with 4 real numbers — confirms signature is applied
        const hasAppliedByteRange = /\/ByteRange\s*\[\s*0\s+\d+\s+\d+\s+\d+\s*\]/i.test(pdfText);
        resolve(hasBlockedSubFilter && hasAppliedByteRange);
        } catch (error) {
          console.error('Error parsing PDF:', error);
          reject(error);
        }
      };

      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsArrayBuffer(file);
    });
  }

  generateReferenceId() {
    this.catUploadService.getOrValidateReferenceId().subscribe(
      (res: any) => {
        if (res.status === 200) {
          //this.messageService.add({ severity: 'success', detail: res.message });
          this.productDetails.controls['referenceNumber'].setValue(
            res.content.reference_id
          );
        }
      },
      (err) => {
        if (
          'error' in err &&
          'content' in err.error &&
          'errors' in err.error.content
        ) {
          this.messageService.add({
            severity: 'error',
            detail: err.error.message,
          });
        }
      }
    );
  }

  getRefIdConsent() {
    let refIdConsent = this.storageService.getRefIdConsent() || null;
    if (refIdConsent === true) this.enableRefIdField = true;
    else {
      this.enableRefIdField = false;
      this.generateReferenceId();
    }
  }

  validateReferenceId() {
    let enteredReferenceId = this.productDetails.value.referenceNumber;
    this.catUploadService
      .getOrValidateReferenceId(enteredReferenceId)
      .subscribe(
        (res: any) => {
          if (res.status === 200) {
            this.onUploadFileDetails();
          }
        },
        (err) => {
          if (
            'error' in err &&
            'content' in err.error &&
            'errors' in err.error.content
          ) {
            this.messageService.add({
              severity: 'error',
              detail: err.error.message,
            });
          }
        }
      );
  }

  setSelectedBranchValue() {
    this.selectedValue = this.storageService.getBranch() || null;
    if (this.selectedValue) {
      this.productDetails.controls['branchName'].setValue(
        this.selectedValue.name
      );
    }
    // Always subscribe so branch updates from the header dropdown are reflected
      this.storageService.branchChange.subscribe((branch: any) => {
      if (branch) {
        this.selectedBranch = branch;
        this.productDetails.controls['branchName'].setValue(branch.name);
      }
      });
    
  }

  //---------------------------------------------------------------------------------------------------//

  removeFileName(index: number) {
    this.uploadFiles.splice(index, 1);
    if (this.uploadFiles.length === 0) {
      this.showFileName = false;
      this.fileName = '';
      this.cleanupPopupPreview();
    } else {
      this.fileName = this.uploadFiles.map((f) => f.name).join(', ');
      this.initPopupPreview(this.uploadFiles[0]);
    }
  }

  async proceedWithMerging() {
    this.spinner.show();
    this.submitted = true;

    const refControl = this.productDetails.get('referenceNumber');
    if (refControl?.invalid) {
      this.productDetails.markAllAsTouched();
      this.spinner.hide();
      return;
    }

    if (this.uploadFiles.length === 0) {
      this.spinner.hide();
      return;
    }

    try {
      if (this.uploadFiles.length === 1) {
        const file = this.uploadFiles[0];

        // Validate file
        let splitName = file.name.split('.');
        if (splitName[splitName.length - 1] !== 'pdf') {
          alert(AUTO_SIGNATURE_CONSTANTS.NOT_VALID_PDF);
          this.spinner.hide();
          return;
        } else if (splitName.length > 2) {
          alert(AUTO_SIGNATURE_CONSTANTS.SINGLE_EXTENSION_REQUIRED);
          this.spinner.hide();
          return;
        }
        const a4ConvertedFile =
          await this.pdfResizeService.convertSingleFileToA4(file);

        // Read the converted file's bytes ONCE and reuse the same buffer for
        // both page-info extraction and Base64 encoding, instead of reading
        // the file twice (previously: readAsArrayBuffer + readAsDataURL).
        const arrayBuffer = await a4ConvertedFile.arrayBuffer();
        await this.extractPdfInfoOnly(arrayBuffer);

        const base64String =
          this.pdfResizeService.arrayBufferToBase64(arrayBuffer);
        this.base64Data = `data:application/pdf;base64,${base64String}`;

        if (
          !this.pdfValidationService.validateBase64String(
            this.base64Data,
            file.name
          )
        ) {
          this.spinner.hide();
          return;
        }
      } else {
        const mergedPdf = await PDFDocument.create();

        // Reset arrays
        this.pageHeight = [];
        this.pageWidth = [];
        this.mergedPages = 0;

        for (let file of this.uploadFiles) {
          // Validate file
          let splitName = file.name.split('.');
          if (splitName[splitName.length - 1] !== 'pdf') {
            alert(AUTO_SIGNATURE_CONSTANTS.NOT_VALID_PDF);
            this.spinner.hide();
            return;
          } else if (splitName.length > 2) {
            alert(AUTO_SIGNATURE_CONSTANTS.SINGLE_EXTENSION_REQUIRED);
            this.spinner.hide();
            return;
          }

          const a4ConvertedFile =
            await this.pdfResizeService.convertSingleFileToA4(file);

          await this.readAndMergePdf(a4ConvertedFile, mergedPdf);
        }

        const mergedPdfBytes = await mergedPdf.save({
          useObjectStreams: true,
          updateFieldAppearances: false,
        });

        this.base64Data = this.pdfResizeService.arrayBufferToBase64(
          mergedPdfBytes.buffer as ArrayBuffer
        );

        if (
          !this.pdfValidationService.validateBase64String(
            this.base64Data,
            'Merged PDF'
          )
        ) {
          this.spinner.hide();
          return;
        }
      }

      this.dataTransferService.setPdfData(this.base64Data);
      this.spinner.hide();
      this.validateReferenceId();
    } catch (error) {
      console.error('Error processing PDF:', error);
      this.messageService.add({
        severity: AUTO_SIGNATURE_CONSTANTS.SEVERITY_ERROR,
        detail: AUTO_SIGNATURE_CONSTANTS.PDF_PROCESSING_ERROR,
      });
      this.spinner.hide();
    }
  }
  async readAndMergePdf(file: File, mergedPdf: PDFDocument): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async () => {
        try {
          const pdfDoc = await PDFDocument.load(reader.result as ArrayBuffer);
          const totalPages = pdfDoc.getPageCount();

          console.log(`Processing PDF with ${totalPages} pages`);

          // Initialize arrays if they don't exist
          if (!this.pageHeight) this.pageHeight = [];
          if (!this.pageWidth) this.pageWidth = [];

          for (let i = 0; i < totalPages; i++) {
            const page = pdfDoc.getPage(i);
            const pageHeight = Math.round(page.getHeight());
            const pageWidth = Math.round(page.getWidth());

            console.log(
              `Page ${i + 1}: Height = ${pageHeight}, Width = ${pageWidth}`
            );

            this.pageHeight.push(pageHeight);
            this.pageWidth.push(pageWidth);
          }

          this.mergedPages += totalPages;

          const copiedPages = await mergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );
          copiedPages.forEach((page) => mergedPdf.addPage(page));

          resolve();
        } catch (error) {
          console.error('PDF processing error:', error);
          reject(error);
        }
      };
      reader.onerror = (error) => {
        console.error('File reader error:', error);
        reject(error);
      };
      reader.readAsArrayBuffer(file);
    });
  }

  //---------------------------------------------------------------------------------------------------------------//

  isMime(bytes: Uint8Array, mime: Mime): boolean {
    return mime.pattern.every((p, i) => !p || bytes[i] === p);
  }

  validateImageMimeType(file: File, callback: (b: boolean) => void) {
    const numBytesNeeded = Math.max(...imageMimes.map((m) => m.pattern.length));
    const blob = file.slice(0, numBytesNeeded);

    const fileReader = new FileReader();

    fileReader.onloadend = (e) => {
      if (!e || !fileReader.result) return;

      const bytes = new Uint8Array(fileReader.result as ArrayBuffer);

      const valid = imageMimes.some((mime) => this.isMime(bytes, mime));

      callback(valid);
    };

    fileReader.readAsArrayBuffer(blob);
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  openUploadModal() {
    this.backupUploadFiles = [...this.uploadFiles];
    this.chooseFile = false;
    this.fileSizeError = false;
    if (this.uploadFiles && this.uploadFiles.length > 0) {
      this.fileName = this.uploadFiles.map((f) => f.name).join(', ');
      this.showFileName = true;
    }
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  cancelUpload() {
    this.closeUploadPopupBtn.nativeElement.click();
    this.fileSizeError = false;
    if (this.backupUploadFiles && this.backupUploadFiles.length > 0) {
      this.uploadFiles = [...this.backupUploadFiles];
    }
    if (this.uploadFiles && this.uploadFiles.length > 0) {
      this.fileName = this.uploadFiles.map((f) => f.name).join(', ');
      this.showFileName = true;
    } else {
      this.uploadFiles = [];
      this.fileName = '';
      this.showFileName = false;
    }
    this.backupUploadFiles = [];
  }

  clearFile() {
    this.uploadFiles = [];
    this.cleanupPopupPreview();
    const inputElement = <HTMLInputElement>(
      document.getElementById('upload_file')
    );
    if (inputElement) inputElement.value = '';
    this.fileSizeError = false;
  }

  async uploadSelFile() {
    // Check if file is selected
    if (!this.showFileName) {
      this.chooseFile = true;
      this.showError('No Files', 'Please select a file to upload', 'warn');
      return;
    }

  if (this.uploadFiles.length === 0) {
    this.chooseFile = true;
    this.showError('No Files', 'Please select a file to upload', 'warn');
    return;
  }

  // Final security check before upload
    try {
      const finalValidation = await Promise.all(
        this.uploadFiles.map((file) =>
          this.pdfSecurityService.validateAndSanitizePDF(file)
        )
      );

      const hasInvalidFiles = finalValidation.some((result) => !result.isValid);

      if (hasInvalidFiles) {
        this.showError(
          'Upload Blocked',
          'Security validation failed. Please select different files.',
          'error'
        );
        return;
      }

      // All validations passed
      this.chooseFile = false;
      this.showFileName = true;
      this.backupUploadFiles = [];

      // Close the modal popup
      this.closeUploadPopupBtn.nativeElement.click();

      // Immediately display Document Preview modal for newly uploaded document
      setTimeout(() => {
        this.previewUploadedFile();
        this.cdr.detectChanges();
      }, 400);

    // Proceed with actual upload logic
    } catch (error) {
      console.error('Upload error:', error);
      this.showError(
        'Upload Failed',
        'An error occurred during upload. Please try again.',
        'error'
      );
    }
  }

 /**
 * Helper to transition to the new Editor Component
 */
  async initPopupPreview(file: File) {
    try {
      const arrayBuffer = await file.arrayBuffer();
      this.popupPreviewBytes = new Uint8Array(arrayBuffer);
      this.loadedPdfDoc = null;
      this.popupPreviewPage = 1;
      this.popupPreviewZoom = 1.0;
      await this.analyzePopupLandscape(this.popupPreviewBytes);
      this.cdr.detectChanges();
      setTimeout(() => this.renderCanvasPage(1), 60);
    } catch (err) {
      console.error('Failed to init popup preview:', err);
    }
  }

  async renderCanvasPage(targetPage: number = this.popupPreviewPage): Promise<void> {
    if (!this.popupPreviewBytes) return;
    this.isRenderingPdf = true;
    this.pdfRenderError = false;
    this.cdr.detectChanges();

    try {
      await this.pdfjsWorkerBootstrap.ready;
      if (!this.loadedPdfDoc) {
        this.loadedPdfDoc = await pdfjsLib.getDocument({ data: this.popupPreviewBytes }).promise;
        this.popupPreviewTotalPages = this.loadedPdfDoc.numPages;
      }

      if (!this.pdfCanvas?.nativeElement) {
        await new Promise((resolve) => setTimeout(resolve, 60));
      }

      const canvas = this.pdfCanvas?.nativeElement;
      if (!canvas) return;

      const page = await this.loadedPdfDoc.getPage(targetPage);
      const unscaledViewport = page.getViewport({ scale: 1 });

      const targetWidth = 560 * (this.popupPreviewZoom || 1.0);
      const dpr = window.devicePixelRatio || 1;
      const scale = (targetWidth * dpr) / unscaledViewport.width;

      const viewport = page.getViewport({ scale });
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      canvas.style.width = `${Math.round(viewport.width / dpr)}px`;
      canvas.style.height = `${Math.round(viewport.height / dpr)}px`;

      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        await page.render({ canvasContext: ctx, viewport }).promise;
      }
    } catch (err) {
      console.error('Error rendering PDF page on canvas:', err);
      this.pdfRenderError = true;
    } finally {
      this.isRenderingPdf = false;
      this.cdr.detectChanges();
    }
  }

  private async analyzePopupLandscape(bytes: Uint8Array) {
    try {
      const pdfDoc = await PDFDocument.load(bytes);
      const pages = pdfDoc.getPages();
      this.popupPreviewTotalPages = pages.length;
      let foundLandscape = false;
      for (const page of pages) {
        const { width, height } = page.getSize();
        const rot = page.getRotation().angle;
        const isSwapped = rot === 90 || rot === 270;
        const effW = isSwapped ? height : width;
        const effH = isSwapped ? width : height;
        if (effW > effH) {
          foundLandscape = true;
          break;
        }
      }
      this.hasLandscapePages = foundLandscape;
    } catch (err) {
      this.hasLandscapePages = false;
    }
  }

  private updatePopupPreviewSource() {
    if (!this.popupPreviewBytes) return;
    this.cleanupPopupPreview();
    const blob = new Blob([this.popupPreviewBytes as any], { type: 'application/pdf' });
    this.popupPreviewPdfSrc = URL.createObjectURL(blob);
  }

  cleanupPopupPreview() {
    if (this.popupPreviewPdfSrc && typeof this.popupPreviewPdfSrc === 'string' && this.popupPreviewPdfSrc.startsWith('blob:')) {
      URL.revokeObjectURL(this.popupPreviewPdfSrc);
      this.popupPreviewPdfSrc = null;
    }
  }

  togglePopupZoom() {
    this.popupPreviewZoom = this.popupPreviewZoom === 1.0 ? 1.25 : this.popupPreviewZoom === 1.25 ? 1.5 : 1.0;
    this.renderCanvasPage(this.popupPreviewPage);
  }

  async rotatePopupLandscape() {
    if (!this.hasLandscapePages || !this.popupPreviewBytes || this.isRotating) return;
    this.isRotating = true;
    try {
      const pdfDoc = await PDFDocument.load(this.popupPreviewBytes);
      const pages = pdfDoc.getPages();
      let anyRotated = false;
      pages.forEach((page) => {
        const { width, height } = page.getSize();
        const rot = page.getRotation().angle;
        const isSwapped = rot === 90 || rot === 270;
        const effW = isSwapped ? height : width;
        const effH = isSwapped ? width : height;
        if (effW > effH) {
          page.setRotation(degrees((rot + 90) % 360));
          anyRotated = true;
        }
      });
      if (anyRotated) {
        this.popupPreviewBytes = await pdfDoc.save();
        this.loadedPdfDoc = null;
        await this.analyzePopupLandscape(this.popupPreviewBytes);
        await this.renderCanvasPage(this.popupPreviewPage);
        if (this.uploadFiles.length > 0) {
          const updatedFile = new File([this.popupPreviewBytes as any], this.uploadFiles[0].name, {
            type: 'application/pdf',
            lastModified: Date.now()
          });
          this.uploadFiles[0] = updatedFile;
        }
        this.messageService.add({
          severity: 'success',
          summary: 'Rotated',
          detail: 'Landscape pages rotated to portrait.'
        });
      }
    } catch (error) {
      console.error('Error rotating popup PDF:', error);
    } finally {
      this.isRotating = false;
      this.cdr.detectChanges();
    }
  }

  triggerChangeFile() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
      this.fileInput.nativeElement.click();
    }
  }

  prevPopupPage() {
    if (this.popupPreviewPage > 1) {
      this.popupPreviewPage--;
      this.renderCanvasPage(this.popupPreviewPage);
    }
  }

  nextPopupPage() {
    if (this.popupPreviewPage < this.popupPreviewTotalPages) {
      this.popupPreviewPage++;
      this.renderCanvasPage(this.popupPreviewPage);
    }
  }

  onPopupPdfLoaded(pdfInfo: any) {
    if (pdfInfo && pdfInfo.numPages) {
      this.popupPreviewTotalPages = pdfInfo.numPages;
    }
    this.cdr.detectChanges();
  }

  previewUploadedFile(index?: number) {
    if (this.uploadFiles && this.uploadFiles.length > 0) {
      this.previewModalMode = 'preview';

      if (typeof index === 'number' && index >= 0 && index < this.uploadFiles.length) {
        // Badge click — preview this specific file individually
        this.activePreviewIndex = index;
        this.previewFile = this.uploadFiles[index];
        this.previewModalFiles = [this.uploadFiles[index]];
        this.previewFileName = this.uploadFiles[index].name;
      } else if (this.uploadFiles.length > 1) {
        // Eye icon click — show all files merged, but keep individual names as title
        this.activePreviewIndex = -1;
        this.previewFile = null;
        this.previewModalFiles = [...this.uploadFiles];
        this.previewFileName = this.uploadFiles.map(f => f.name).join(', ');
      } else {
        // Single file, eye icon click
        this.activePreviewIndex = 0;
        this.previewFile = this.uploadFiles[0];
        this.previewModalFiles = [this.uploadFiles[0]];
        this.previewFileName = this.uploadFiles[0].name;
      }

      this.previewModalVisible = true;
      this.cdr.detectChanges();
    }
  }

  onUploadConfirmed(event: { file: File; files?: File[]; base64?: string; arrayBuffer?: ArrayBuffer }) {
    const finalFiles = event.files && event.files.length > 0 ? event.files : (this.stagedUploadFiles.length > 0 ? this.stagedUploadFiles : (event.file ? [event.file] : []));
    const finalFile = event.file || finalFiles[0];
    if (finalFile) {
      const incomingFiles = finalFiles.length > 0 ? finalFiles : [finalFile];

      if (!this.uploadFiles || this.uploadFiles.length === 0) {
        this.uploadFiles = [...incomingFiles];
      } else {
        for (const newFile of incomingFiles) {
          const existingIdx = this.uploadFiles.findIndex((f) => f.name === newFile.name);
          if (existingIdx !== -1) {
            this.uploadFiles[existingIdx] = newFile;
          } else {
            this.uploadFiles.push(newFile);
          }
        }
      }

      this.fileName = this.uploadFiles.map((f) => f.name).join(', ');
      this.showFileName = true;
      this.chooseFile = false;

      this.storageService.setfiletype('pdf');

      const count = incomingFiles.length || 1;
      this.messageService.add({
        severity: 'success',
        summary: count === 1 ? 'File Uploaded' : 'Files Uploaded',
        detail: count === 1 ? `${finalFile.name} uploaded successfully` : `${count} files uploaded successfully`,
        life: 3000,
      });
    }
    this.stagedUploadFiles = [];
    this.previewModalMode = 'preview';
    this.cdr.detectChanges();
  }

  onUploadCancelled() {
    this.stagedUploadFiles = [];
    this.previewModalMode = 'preview';
    this.cdr.detectChanges();
  }

  onPreviewFileSaved(event: { file: File; files?: File[] }) {
    if (event.files && event.files.length > 1) {
      // Multi-file save: replace each file in uploadFiles by name
      for (const updatedFile of event.files) {
        const idx = this.uploadFiles.findIndex(f => f.name === updatedFile.name);
        if (idx !== -1) {
          this.uploadFiles[idx] = updatedFile;
        }
        // If not found by name, it was already the right file — no push needed
      }
      this.activePreviewIndex = -1;
      this.previewFile = null;
      this.previewModalFiles = [...event.files];
      this.previewFileName = this.uploadFiles.map(f => f.name).join(', ');
    } else {
      let idx = this.activePreviewIndex;
      if (idx < 0 || idx >= this.uploadFiles.length) {
        idx = this.uploadFiles.findIndex((f) => f.name === event.file.name);
      }
      if (idx !== -1 && this.uploadFiles[idx]) {
        this.uploadFiles[idx] = event.file;
      } else {
        this.uploadFiles.push(event.file);
      }
      this.previewFile = event.file;
      this.previewFileName = event.file.name;
    }
    this.fileName = this.uploadFiles.map((f) => f.name).join(', ');
    this.cdr.detectChanges();
  }

  async editFile() {
    if (!this.showFileName || this.uploadFiles.length === 0) {
      this.showError('No Files', 'Please select a file to edit', 'warn');
      return;
  }

  try {
    let finalBase64: string;
    let finalFileName: string;

    // ONLY show "Merging" and run merge logic if more than 1 file is selected
    if (this.uploadFiles.length > 1) {
      this.messageService.add({ 
        severity: 'info', 
        summary: 'Merging', 
        detail: 'Preparing documents...' 
      });

      const mergedPdf = await PDFDocument.create();
      for (const file of this.uploadFiles) {
        const fileArrayBuffer = await file.arrayBuffer();
        const pdf = await PDFDocument.load(fileArrayBuffer);
        const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
        copiedPages.forEach((page) => mergedPdf.addPage(page));
      }
      finalBase64 = await mergedPdf.saveAsBase64({ dataUri: true });
      finalFileName = "Merged_Documents.pdf";
    } 
    else {
      // If only 1 file, skip merging and just read it directly
      const file = this.uploadFiles[0];
      finalBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: any) => resolve(e.target.result);
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(file);
      });
      finalFileName = file.name;
    }

    // Open editor with the resulting file
    this.openPdfEditor(finalBase64, finalFileName);

  } catch (error) {
    console.error('File Preparation Error:', error);
    this.showError('Error', 'Could not prepare file for editing', 'error');
  }
  }

  private openPdfEditor(pdfData: string, fileName: string) {
    // Pass the data URI directly — pdf-editor handles data: URIs natively
    this.currentPdfToEdit = pdfData;
    this.currentFileName = fileName;
    this.isEditorVisible = true;
  }


  handleFinalUpload(modifiedBase64: string) {
    this.isEditorVisible = false;

    const base64Data = modifiedBase64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const blob = new Blob([byteNumbers], { type: 'application/pdf' });
  
  // Create the final file
  const editedFile = new File([blob], "final_edited_document.pdf", {
      type: 'application/pdf',
    });

    // CRITICAL: Replace the array with the single merged/edited file
    this.uploadFiles = [editedFile];

    this.messageService.add({
      severity: 'info', // Use info or success
      summary: 'Document Saved',
      detail: 'Changes applied. Proceeding with upload.',
    });

    // Trigger final upload logic
    this.uploadSelFile();
  }

  async onUploadFileDetails() {
    this.submitted = true;
    if (this.productDetails.value.branchName === 'Selected Branch') {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please select state and branch to proceed',
      });
      this.noBranch = true;
      return;
    }
    if (
      this.uploadFiles.length === 0 ||
      this.productDetails.value.referenceNumber === ''
    ) {
      return;
    }
    this.uploadFileData = this.productDetails.value;
    this.uploadFileData.page = 'esign';
    this.uploadFileData.totalPages = this.mergedPages;
    this.uploadFileData.pageHeight = this.pageHeight;
    this.uploadFileData.pageWidth = this.pageWidth;

    this.uploadFileData.file = this.uploadFileData.base64Doc =
      this.base64Data.split(',')[1];
    this.uploadFileData.fileName = this.fileName;
    this.uploadFileData.referenceNumber =
      this.productDetails.value.referenceNumber;
    this.uploadFileData.uploadFiles = this.uploadFiles;
    this.uploadFileData.base64Doc = this.base64Data;
    this.uploadFileChange.emit(this.uploadFileData);
  }

  goToSignIn() {
    this.proceedWithMerging();
  }

  // ------- New drag and drop methods

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  async onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      // Convert FileList to Array
      const fileArray: File[] = Array.from(files);

      // Filter only PDF files
      const pdfFiles = fileArray.filter(
        (file) =>
          file.type === 'application/pdf' ||
          file.name.toLowerCase().endsWith('.pdf')
      );


      // Check if any non-PDF files were dropped
      const nonPdfFiles = fileArray.filter(
        (file) =>
          file.type !== 'application/pdf' &&
          !file.name.toLowerCase().endsWith('.pdf')
        );

      if (nonPdfFiles.length > 0) {
        this.messageService.add({
          severity: 'error',
          detail: `Only PDF files are allowed. Rejected files: ${nonPdfFiles
            .map((f) => f.name)
            .join(', ')}`,
        });
      }

      // Process only PDF files if any
      if (pdfFiles.length > 0) {
        await this.processValidFiles(pdfFiles);
      }
    }
  }

  sanitizeHtml(dirty: string): string {
    return DOMPurify.sanitize(dirty, {
      ALLOWED_TAGS: ['span', 'p', 'br'],
      ALLOWED_ATTR: [],
      FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'svg'],
    });
  }

  sanitizeTextOnly(dirty: string): string {
    return DOMPurify.sanitize(dirty, { ALLOWED_TAGS: [] });
  }

  private async processFiles(base64: string | null, fileArray: File[]) {
    const maxFileSize: number = 15 * 1024 * 1024; // 15MB — keeps Base64 output (~1.33x) safely under eMudhra's 25MB payload limit
    this.resetErrors?.();

    // Size validation
    const oversizedFiles = fileArray.filter((file) => file.size > maxFileSize);
    if (oversizedFiles.length > 0) {
      this.fileSizeError = true;
      this.messageService.add({
        severity: 'error',
        detail: `Files exceeding 15MB limit: ${oversizedFiles
          .map((f) => f.name)
          .join(', ')}. Please upload a smaller PDF so it can be processed within the e-sign gateway's size limits.`,
      });
      return;
    }

    //Security validation using SHARED SERVICE 
    try {
      const securityResults = await Promise.all(
        fileArray.map(
          (file) => this.pdfSecurityService.validateAndSanitizePDF(file) // ← SERVICE, NOT LOCAL
        )
      );

      const eSignedFiles = fileArray.filter(
        (_, index) => securityResults[index].isESigned === true
      );

      const maliciousFiles = fileArray.filter(
        (_, index) =>
          !securityResults[index].isValid && !securityResults[index].isESigned
      );

      if (eSignedFiles.length > 0) {
        this.securityError = true;
        this.messageService.add({
          severity: 'warn',
          summary: 'Electronic Signature Detected',
          detail: `File contains electronic signature: ${eSignedFiles
            .map((f) => f.name)
            .join(', ')}`,
        });
        return;
      }

      if (maliciousFiles.length > 0) {
        this.securityError = true;
        const errorDetails = maliciousFiles
          .map((file) => {
            const fileIndex = fileArray.indexOf(file);
            return `• ${file.name}: ${securityResults[fileIndex].reason}`;
          })
          .join('\n');

        this.messageService.add({
          severity: 'error',
          summary: 'Security Threat Detected',
          detail: `The following PDF(s) failed security validation:\n${errorDetails}`,
          life: 5000,
        });
        return;
      }
    } catch (error) {
      console.error('Security validation error:', error);
      this.securityError = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Failed',
        detail: 'Unable to validate PDF security. Please try again.',
      });
      return;
    }

    //Generate secure preview
    if (fileArray.length > 0) {
      this.safePreviewContent =
        await this.pdfSecurityService.generateSecurePreview(fileArray[0]);
    }

    //All validations passed
    this.fileSizeError = false;
    this.signatureError = false;
    this.securityError = false;
    this.uploadFiles.push(...fileArray);
    this.showFileName = true;
    this.chooseFile = false;
    this.fileName = this.uploadFiles.map((file) => file.name).join(', ');
    this.storageService.setfiletype('pdf');

    const count = fileArray.length;
    this.messageService.add({
      severity: 'success',
      summary: count === 1 ? 'File Ready' : 'Files Ready',
      detail:
        count === 1
          ? `${count} file validated and ready to upload`
          : `${count} files validated and ready to upload`,
      life: 3000,
    });
  }

  private async generateSecurePreview(file: File) {
    try {
      const arrayBuffer = await file.arrayBuffer();
      const uint8Array = new Uint8Array(arrayBuffer);
      const textContent = new TextDecoder('latin1').decode(uint8Array);

      // Extract and sanitize first 1000 characters
      const previewText = textContent.substring(0, 1000);

      // Use DOMPurify to strip ALL HTML/script tags
      this.safePreviewContent =
        this.safeHtmlService.sanitizeTextOnly(previewText);

      // If preview is empty or too short, show generic message
      if (!this.safePreviewContent || this.safePreviewContent.length < 10) {
        this.safePreviewContent =
          'PDF uploaded securely. Preview not available.';
      }
    } catch (error) {
      console.error('Preview generation error:', error);
      this.safePreviewContent =
        'PDF uploaded securely. Use download to view full content.';
    }
  }

  removeFile() {
    this.fileName = '';
    // Reset file input
    const fileInput = document.getElementById(
      'upload_file'
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  private async extractPdfInfoOnly(arrayBuffer: ArrayBuffer): Promise<void> {
    const pdfDoc = await PDFDocument.load(arrayBuffer);
    const totalPages = pdfDoc.getPageCount();

    console.log(`Processing PDF with ${totalPages} pages`);

    this.pageHeight = [];
    this.pageWidth = [];

    for (let i = 0; i < totalPages; i++) {
      const page = pdfDoc.getPage(i);
      const pageHeight = Math.round(page.getHeight());
      const pageWidth = Math.round(page.getWidth());

      this.pageHeight.push(pageHeight);
      this.pageWidth.push(pageWidth);
    }

    this.mergedPages = totalPages;
  }

  // === Cloud upload Methods ===

  // --- Google Drive Methods ---

  openGoogleDrive() {
    this.showGoogleDriveModal = true;
  }

  onGoogleDriveFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }) {
    const isAlreadySelected = this.uploadFiles.some(
      (file) => file.name === event.fileName && file.size === event.file.size
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      return;
    }

    if (event.file.size === 0) {
      // console.error('Received empty file:', event.fileName);
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      return;
    }

    if (this.uploadFiles.length === 0) {
      this.fileName = event.fileName;
      this.base64Data = event.base64;
    } else {
      this.fileName = this.fileName + ', ' + event.fileName;
    }

    this.processFiles(event.base64, [event.file]);
    // console.log('Google Drive file selected:', event.fileName);
  }

  onGoogleDriveModalClosed() {
    this.showGoogleDriveModal = false;
  }
  // --- End Google Drive Methods ---

  // --- Link Upload Methods ---
  openLink() {
    this.closeUploadPopupBtn.nativeElement.click();
    this.showLinkModal = true;
  }

  onLinkFileSelected(event: { file: File; base64: string; fileName: string }) {
    // Check if file is already selected
    const isAlreadySelected = this.uploadFiles.some(
      (file) => file.name === event.fileName && file.size === event.file.size
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      return;
    }

    // Check if file is empty
    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      return;
    }

    // Update the fileName display
    if (this.uploadFiles.length === 0) {
      this.fileName = event.fileName;
    } else {
      this.fileName = this.fileName + ', ' + event.fileName;
    }

    // Show the filename in the UI
    this.showFileName = true;
    this.chooseFile = false;

    // Process the file using existing validation logic
    this.processFiles(event.base64, [event.file]);

    this.messageService.add({
      severity: 'success',
      detail: `Successfully selected ${event.fileName} from URL`,
    });

    // console.log('Link file selected:', event.fileName);
  }

  onLinkModalClosed() {
    this.showLinkModal = false;
    // console.log('Link modal closed');
  }

  // --- End Link Upload Methods ---

  // --- Dropbox Methods ---
  openDropbox() {
    // this.closeUploadPopupBtn.nativeElement.click();
   if (!this.dropboxEnabled) return;
    this.showDropboxModal = true;
  }

  onDropboxFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }) {
    const isAlreadySelected = this.uploadFiles.some(
      (file) => file.name === event.fileName && file.size === event.file.size
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      return;
    }

    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      return;
    }

    // Process the file using existing validation logic
    this.processFiles(event.base64, [event.file]);

    this.messageService.add({
      severity: 'success',
      detail: `Successfully selected ${event.fileName} from Dropbox`,
    });

    // console.log('Dropbox file selected:', event.fileName);
  }

  onOneDriveFileSelected(event: {
    file: File;
    base64: string;
    fileName: string;
  }) {
    // Check if file is already selected
    const isAlreadySelected = this.uploadFiles.some(
      (file) => file.name === event.fileName && file.size === event.file.size
    );

    if (isAlreadySelected) {
      this.messageService.add({
        severity: 'warn',
        detail: `File ${event.fileName} is already selected`,
      });
      return;
    }

    // Check if file is empty
    if (event.file.size === 0) {
      this.messageService.add({
        severity: 'error',
        detail: `File ${event.fileName} is empty`,
      });
      return;
    }

    // Process the file using existing validation logic
    this.processFiles(event.base64, [event.file]);

    this.messageService.add({
      severity: 'success',
      detail: `Successfully selected ${event.fileName} from Dropbox`,
    });

    // console.log('Dropbox file selected:', event.fileName);
  }

  onDropboxModalClosed() {
    this.showDropboxModal = false;
  }

  // --- End Dropbox Methods ---

  // --- OneDrive Methods ---
  openOneDrive() {
    this.showOneDriveModal = true;
    // console.log('Opening OneDrive modal...');
  }
  onOneDriveModalClosed() {
    this.showOneDriveModal = false;
    // console.log('OneDrive modal closed');
  }
  // --- End OneDrive Methods ---
  getTotalFileSize(): string {
    const totalBytes = this.uploadFiles.reduce(
      (sum, file) => sum + file.size,
      0
    );

    if (totalBytes < 1024) {
      return `${totalBytes} B`;
    } else if (totalBytes < 1024 * 1024) {
      return `${(totalBytes / 1024).toFixed(2)} KB`;
    } else {
      return `${(totalBytes / (1024 * 1024)).toFixed(2)} MB`;
    }
  }

  onReferencePaste(event: ClipboardEvent): void {
    if (!this.enableRefIdField) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    const clipboardData = event.clipboardData?.getData('text') || '';
    const sanitized = clipboardData.replace(/[^a-zA-Z0-9_-]/g, '');
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const newValue = input.value.slice(0, start) + sanitized + input.value.slice(end);
    this.productDetails.get('referenceNumber')?.setValue(newValue);
  }
}
